import { DetailedReactHTMLElement, ReactNode, cloneElement } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { TConfirmModalProps } from "../../types/common";
import { Visibility } from "./Visibility";
import ErrorSlate from "./ErrorSlate";

type TModalProps = {
  show: boolean;
  onHide(): void;
  title: string;
  body: ReactNode;
  onOkayPress?(): void;
  formId?: string;
  okayType?: "submit" | "button";
  okayLoading?: boolean;
  hideOkay?: boolean;
  hideActions?: boolean;
  okayLoadingText?: string;
  size?: "sm" | "lg" | "xl";
  error?: any;
};

export const CommonModal = (props: TModalProps) => {
  const {
    show,
    onHide,
    title,
    body,
    onOkayPress,
    formId,
    okayType,
    okayLoading,
    okayLoadingText,
    hideOkay,
    hideActions,
    size,
    error,
  } = props;

  const renderBody = (ele: ReactNode, properties: any) =>
    ele
      ? cloneElement(
          ele as DetailedReactHTMLElement<any, HTMLElement>,
          properties,
        )
      : null;

  const okayText = okayType === "submit" ? "Submit" : "Okay";

  const handleModalSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (onOkayPress) {
      onOkayPress();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size || "lg"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <form id={formId} onSubmit={handleModalSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{renderBody(body, props)}</Modal.Body>
        <Visibility show={!hideActions}>
          <Modal.Footer>
            <Button onClick={onHide} className="btn-cancel">
              Close
            </Button>
            {hideOkay ? null : (
              <Button
                type={okayType || "button"}
                form={formId}
                className="btn-theme"
                disabled={Object.keys(error?.data || {}).length > 0}
              >
                {okayLoading ? okayLoadingText : okayText}
              </Button>
            )}
          </Modal.Footer>
        </Visibility>
      </form>
    </Modal>
  );
};

export const ConfirmModal = (props: TConfirmModalProps) => {
  const { show, onHide, title, body, onOkayPress, submitting, error } = props;

  const renderBody = (ele: ReactNode, properties: any) =>
    ele
      ? cloneElement(
          ele as DetailedReactHTMLElement<any, HTMLElement>,
          properties,
        )
      : null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error ? (
          <ErrorSlate
            message={
              error?.message || error?.detail || "An unknown error occured"
            }
          />
        ) : null}
        {renderBody(body, props)}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} className="btn-cancel">
          Cancel
        </Button>
        <Button onClick={onOkayPress} className="btn-theme">
          {submitting ? "Submitting..." : "Okay"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
